import { Link } from "react-router-dom";
import { GraduationCap, Sparkles, Trophy } from "lucide-react";
import { useAuth } from "@/lib/auth";
import { openAI } from "@/components/ai/stream";
import { TourButton } from "@/components/shell/IntroVideo";

const STEPS = [
  { n: 1, t: "Pick your level", d: "Beginner, Intermediate or Expert. Each one unlocks more markets.", to: "/account", I: GraduationCap },
  { n: 2, t: "Place a practice bet", d: "$1,000 of paper money on sports, crypto, politics and more.", to: "/predict", I: Trophy },
  { n: 3, t: "Ask the AI", d: "Get any market or pick explained in plain English.", I: Sparkles },
];

export const GettingStarted = () => {
  const { profile } = useAuth();
  if (profile && localStorage.getItem("onboard_done") === "1") return null;
  return (
    <section className="glass p-5 space-y-3" data-testid="getting-started">
      <div className="flex items-center justify-between"><h2 className="font-head font-semibold">Start here</h2>
        {profile && <button onClick={(e) => { localStorage.setItem("onboard_done", "1"); e.currentTarget.closest("section").remove(); }} className="text-xs text-slate-500 underline" data-testid="getting-started-dismiss">Hide</button>}</div>
      <TourButton className="w-full sm:w-auto" />
      <div className="grid sm:grid-cols-3 gap-3">
        {STEPS.map((s) => {
          const body = <><div className="flex items-center gap-2 font-semibold text-sm"><span className="w-6 h-6 rounded-full bg-[var(--cyan)]/15 text-[var(--cyan)] text-xs flex items-center justify-center font-num">{s.n}</span>{s.t}</div>
            <p className="text-xs text-slate-400 mt-1.5">{s.d}</p></>;
          const cls = "block text-left rounded-xl border border-[var(--line)] p-3 hover:border-[var(--cyan)] transition-colors";
          return s.to ? <Link key={s.n} to={profile || s.n === 2 ? s.to : "/account"} className={cls} data-testid={`start-step-${s.n}`}>{body}</Link> :
            <button key={s.n} onClick={() => openAI({})} className={cls} data-testid={`start-step-${s.n}`}>{body}</button>;
        })}
      </div>
    </section>
  );
};
